<template>
    <v-dialog v-model="open" width="650" :persistent="true">
        <v-card class="dialog-box">
            <div class="connection-splicing-title-container d-flex justify-space-between align-center">
                    <h2 :style="{ color: '#4fa2b7' }"> New Connection</h2>
                    <v-btn @click="openSplitterForm"
                        :class="isSplitterFormOpen ? 'connection-splicing-button-active' : 'connection-splicing-button'">
                        New Equipment +
                    </v-btn>
                </div>
                <div v-if="!isSplitterFormOpen && !isSplitter"
                    class="d-flex justify-space-between align-center mb-10 connection-splicing-form-container">
                    <div class="connection-splicing-form-item">
                        <label>From</label>
                        <treeselect v-model="selectedFiberOrPort" :options="fiberOrPortOptions" :disabled="!(!!selectedPort)"
                            disable-fuzzy-matching :default-expand-level="0">
                            <label slot="option-label" slot-scope="{ node }">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">{{ node.label }}</span>
                                    </template>
                                    <span>{{ node.label }}</span>
                                </v-tooltip>
                            </label>
                        </treeselect>
                    </div>
                    <div class="connection-splicing-form-item">
                        <label>To</label>
                        <treeselect :disabled="isSplitterDisabled" v-model="selectedSplitter" :options="splitterOptions"
                            disableFuzzyMatching :default-expand-level="0">
                            <label slot="option-label" slot-scope="{ node }">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">{{ node.label }}</span>
                                    </template>
                                    <span>{{ node.label }}</span>
                                </v-tooltip>
                            </label>
                        </treeselect>
                    </div>
                    <div class="connection-splicing-form-item">
                        <treeselect v-model="selectedPort" :disabled="!(!!selectedSplitter)" disableFuzzyMatching
                            :options="portOptions" valueFormat="object" :default-expand-level="0">
                            <label slot="option-label" slot-scope="{ node }">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">{{ node.label }}</span>
                                    </template>
                                    <span>{{ node.label }}</span>
                                </v-tooltip>
                            </label>
                        </treeselect>
                    </div>
                </div>
                <div v-if="!isSplitterFormOpen && isSplitter"
                    class="d-flex justify-space-between align-center mb-10 connection-splicing-form-container">
                    <div class="connection-splicing-form-item">
                        <label>From</label>
                        <treeselect :disabled="isSplitterDisabled" v-model="selectedSplitter" :options="splitterOptions"
                            disableFuzzyMatching :default-expand-level="0">
                            <label slot="option-label" slot-scope="{ node }">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">{{ node.label }}</span>
                                    </template>
                                    <span>{{ node.label }}</span>
                                </v-tooltip>
                            </label>
                        </treeselect>
                    </div>
                    <div class="connection-splicing-form-item">
                        <treeselect v-model="selectedPort" :disabled="!(!!selectedSplitter)" disableFuzzyMatching
                            :options="portOptions" valueFormat="object" :default-expand-level="0">

                            <label slot="option-label" slot-scope="{ node }">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">{{ node.label }}</span>
                                    </template>
                                    <span>{{ node.label }}</span>
                                </v-tooltip>
                            </label>
                        </treeselect>
                    </div>
                    <div class="connection-splicing-form-item">
                        <label>To</label>
                        <treeselect v-model="selectedFiberOrPort" :options="fiberOrPortOptions" :disabled="!(!!selectedPort)"
                            disableFuzzyMatching :default-expand-level="0">

                            <label slot="option-label" slot-scope="{ node }">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">{{ node.label }}</span>
                                    </template>
                                    <span>{{ node.label }}</span>
                                </v-tooltip>
                            </label>
                        </treeselect>
                    </div>
                </div>
                <div v-if="isSplitterFormOpen"
                    class="d-flex justify-space-between align-center mb-10 connection-splicing-form-container">
                    <div class="connection-splicing-form-item">
                        <input placeholder="Label" class="connection-splicing-input" v-model="splitterLabel">
                    </div>
                    <div class="connection-splicing-form-item">
                        <treeselect v-model="splitterMaterialId" placeholder="Equipment" :options="splitterMaterialOptions">

                            <label slot="option-label" slot-scope="{ node }">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">{{ node.label }}</span>
                                    </template>
                                    <span>{{ node.label }}</span>
                                </v-tooltip>
                            </label>
                        </treeselect>
                    </div>
                </div>
                <v-card-actions>
                    <v-btn @click="$emit('close-connect-to')" :ripple="false" class="secondary-button" text>
                        {{ $t("Cancel") }}
                    </v-btn>
                    <v-btn :disabled="isDisabled" @click="saveObject" :ripple="false" class="main-button" text :loading="loading">
                        {{ $t("Save") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>
  
<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import { mapActions } from "vuex";
export default {
    name: "CreateConnectionForm",

    components: {
        InputField
    },
    props: {
        objectEndpoint: {
            type: String
        },
        objectId: {
            type: Number
        },
        open: {
            type: Boolean
        },
        objectUuid: {
            type: String
        },
        isSplitter: {
            type: Boolean
        },
        originCables: {
            type: Array
        },
        destinationCables: {
            type: Array
        },
        connections: {
            type: Array
        },
        selectedConnectionPoint: {
            type: [Array, Object]
        },
        splitters: {
            type: Array
        },
        isTechLocal: {
            type: Boolean,
            default: false
        },
        side: {
            type: String 
        },
        networkLevel: {
            type: String,
            required: true
        }
    },
  
    data() {
      return {
        splitterPortsCache: {},
        isSplitterFormOpen: false,
        splitterMaterialOptions: [],
        splitterOptions: [],
        portOptions: [],
        fiberOrPortOptions: [],
        selectedSplitter: null,
        selectedPort: null,
        selectedFiberOrPort: null,
        splitterMaterialId: null,
        splitterLabel: null,
        isSplitterDisabled: false,
        loading: false,
        fibersCache: [],
        portsCache: []
      }
    },
  
    mounted() {
        this.getObjectSplitters();
        this.loadSplitterMaterialOptions();
        //set origin fiber options
        this.getCableOptions();
        this.setPortOrSplitterId();
        this.setPortAndFiberOptions();
    },
  
    watch: {
        selectedSplitter(value){
            if(value && Object.keys(this.splitterPortsCache).length !== 0){
                const options = [];
                if(this.isTechLocal && this.side === 'destination'){
                    this.splitterPortsCache[value].outputs.forEach(port => {
                        if(!port.connectedFiber && !port.connectedPort){
                            const isNotFree = this.portIsFree(port.pt_id);
                            if(!isNotFree){
                                options.push({
                                    id: port.pt_id,
                                    label: `Output Port ${port.pt_nr_in_splitter}`
                                })
                            }
                        }
                    });
                }else{
                    this.splitterPortsCache[value].inputs.forEach(port => {
                        if(!port.connectedFiber && !port.connectedPort){
                            const isNotFree = this.portIsFree(port.pt_id);
                            if(!isNotFree){
                                options.push({
                                    id: port.pt_id,
                                    label: `Input Port ${port.pt_nr_in_splitter}`
                                })
                            }
                        }
                    });
                    if(this.isSplitter){
                        this.splitterPortsCache[value].outputs.forEach(port => {
                            if(!port.connectedFiber && !port.connectedPort){
                                const isNotFree = this.portIsFree(port.pt_id);
                                if(!isNotFree){
                                    options.push({
                                        id: port.pt_id,
                                        label: `Output Port ${port.pt_nr_in_splitter}`
                                    })
                                }
                            }
                        });
                    }
                }
                
                this.portOptions = [...options];
            }else{
                this.selectedPort = null;
            }
        },
        selectedPort(value){
            if(value){
                if(this.isSplitter){
                    const isInput = value.label.includes('Input');
                    const splitterSelectedHierarchy = this.getSplitterHierarchy(this.selectedSplitter);
                    if(isInput){
                        const portOptions = this.getOriginAndDestinationSplitterOptions(isInput,splitterSelectedHierarchy);
                        if(splitterSelectedHierarchy > 1){
                            this.fiberOrPortOptions = [...portOptions];
                        }else{
                            this.fiberOrPortOptions = [...this.fiberOrPortOptions,...portOptions];
                        }
                    }else{
                        /*get options to destination, origin and inports */
                        const portOptions = this.getOriginAndDestinationSplitterOptions(isInput,splitterSelectedHierarchy);
                        const fiberOptions = this.getOriginAndDestinationCableOptions();
                        const allOptions = [...fiberOptions, ...portOptions]
                        this.fiberOrPortOptions = [...allOptions];
                    }
                }
            }else{
                this.selectedFiberOrPort = null;
            }
        }
    },
  
    computed: {
      isDisabled(){
        let isDisabled;
        if(this.isSplitterFormOpen){
            isDisabled = !!this.splitterMaterialId && !!this.splitterLabel;
        }else{
            isDisabled = !!this.selectedSplitter && !!this.selectedPort  && !!this.selectedFiberOrPort && this.isPortOrFiber();
        }
        return !isDisabled
      }
    },
    methods: {
        ...mapActions([
            "fetchStockMaterialsList",
            "fetchSplittersInObject",
            "createSplitter"
        ]),
        getCableOptions(){
            let originOptions = [];
            let destinationOptions = [];
            if(this.isTechLocal && this.side === 'destination'){
                destinationOptions = this.getDestinationCableOptions();
            }else{
                originOptions = this.getOriginCableOptions();
            }
            this.fiberOrPortOptions = [...originOptions, ...destinationOptions];
        },
        isPortOrFiber(){
            //chek if it is a fiber or port
            const portFound = this.portsCache.find(item => item === this.selectedFiberOrPort);
            const fiberFound = this.fibersCache.find(item => item === this.selectedFiberOrPort);
            return (!!fiberFound || !!portFound);
        },
        async saveObject() {
            if(this.isSplitterFormOpen){
                await this.createEquipment();
            }else{
                const splitter = this.splitterPortsCache[this.selectedSplitter];
                const fiberOrPort = this.getfiberOrPortObject();
                const isInput = this.selectedPort.label.includes('Input');
                if(isInput){
                    const port = splitter.inputs.find(item => item.pt_id === this.selectedPort.id);
                    port.type = "port";
                    this.$emit('create-connection-splitter', fiberOrPort.obj, port, isInput);
                    this.$emit("select-item","destination", port, false);
                    this.$emit("select-item","origin", fiberOrPort.obj, fiberOrPort.isOrigin);
                }else{
                    const port = splitter.outputs.find(item => item.pt_id === this.selectedPort.id);
                    port.type = "port";
                    this.$emit('create-connection-splitter', fiberOrPort.obj, port, isInput);
                    this.$emit("select-item", "origin", port, false);
                    this.$emit("select-item", "destination", fiberOrPort.obj, fiberOrPort.isOrigin);
                }
                this.$emit('close-connect-to');
            }
        },
        async createEquipment() {
            const data = this.prepareNewSplitterData();
            this.loading = true;
            try {
                let newSplitter = await this.createSplitter(data);
                this.addSplitter(newSplitter);
                this.resetSplitterForm();
                this.$emit("add-splitter", newSplitter);
            } catch (e) {
                console.log(e);
            }finally{
                this.loading = false;
            }
        },
        addSplitter(splitter){
            this.splitterOptions.push({
                id: splitter.sp_id,
                label: splitter.sp_label
            });
            let obj = {};
            //populate cache object with ports of every splitter
            obj[splitter.sp_id] = {inputs: [...splitter.inPorts], outputs: [...splitter.outPorts]};
            //populate cache object with ports of every splitter
            this.splitterPortsCache = {...this.splitterPortsCache, ...obj};
            //add ports to ports cache
            splitter.inPorts.forEach(port => {
                this.portsCache.push(port.pt_id);
            });
            splitter.outPorts.forEach(port => {
                this.portsCache.push(port.pt_id);
            });
        },
        resetSplitterForm(){
            this.splitterLabel = null;
            this.splitterMaterialId = null;
        },
        prepareNewSplitterData() {
            let dataToSend = {
                label: this.splitterLabel,
                material_id: this.splitterMaterialId
            };
            if (this.objectEndpoint === "closures") {
                dataToSend.closure_id = this.objectId;
            } else if (this.objectEndpoint === "technicallocals") {
                dataToSend.technical_local_id = this.objectId;
            }
            return dataToSend;
        },
        openSplitterForm(){
            this.isSplitterFormOpen = !this.isSplitterFormOpen;
        },
        async loadSplitterMaterialOptions() {
            try {
                const options = [];
                const response = await this.fetchStockMaterialsList({
                    workspace_uuid: this.$store.getters.workspace.uuid,
                    material_family_id: "sp",
                    network_level_id: this.networkLevel,
                    append: "family_specific_fields"
                });
                response.forEach(item =>{
                    options.push(
                        {
                            id: item.sm_id,
                            label: this.getSplitterLabel(item)
                        }
                    );
                });
                this.splitterMaterialOptions = [...options];
            } catch (e) {
                console.log(e);
            }
        },
        getSplitterLabel(splitter){
            let label;
            const ports = `(${splitter.family_specific_fields.sms_in_ports}:${splitter.family_specific_fields.sms_out_ports})`
            label = splitter.sm_short_description ? `${splitter.sm_short_description} ${ports}` : `${splitter.sm_description} ${ports}`;
            return label;
        },
        setPortAndFiberOptions(){
            this.splitters.forEach(splitter => {
                splitter.inPorts.forEach(port => {
                    this.portsCache.push(port.pt_id);
                });
                splitter.outPorts.forEach(port => {
                    this.portsCache.push(port.pt_id);
                });
            });
            this.originCables.forEach(cable => {
                cable.fibers.forEach(fiber =>{
                    this.fibersCache.push(fiber.fb_id);
                })
            })
            this.destinationCables.forEach(cable => {
                cable.fibers.forEach(fiber =>{
                    this.fibersCache.push(fiber.fb_id);
                })
            });
        },
        getObjectSplitters() {
            const options = [];
            let obj = {};
            if(!this.isSplitter){
                //populate cache object with port for every splitter
                this.splitters.forEach(splitter =>{
                    const splitterNivel = this.getSplitterHierarchy(splitter.sp_id);
                    if(splitterNivel <= 1){
                        //populate cache object with ports of every splitter
                        obj[splitter.sp_id] = {inputs: [...splitter.inPorts], outputs: [...splitter.outPorts]};
                        //create options array
                        options.push(
                            {
                                id: splitter.sp_id,
                                label: splitter.sp_label
                            }
                        )
                    }
                });
            }else{
                //populate cache object with port for every splitter
                this.splitters.forEach(splitter =>{
                    //populate cache object with ports of every splitter
                    obj[splitter.sp_id] = {inputs: [...splitter.inPorts], outputs: [...splitter.outPorts]};
                    //create options array
                    options.push(
                        {
                            id: splitter.sp_id,
                            label: splitter.sp_label
                        }
                    )
                });   
            }
            this.splitterOptions = [...options];
            //populate cache object with ports of every splitter
            this.splitterPortsCache = {...obj};
        },
        portIsFree(id){
            let isNotFree = false;
            const destinationUsesPort = this.connections.find(item => item.destination.id === id);
            destinationUsesPort && (isNotFree = true);
            if(!isNotFree){
                const originUsesPort = this.connections.find(item => item.origin.id === id);
                originUsesPort && (isNotFree = true);
            }
            return isNotFree;
        },
        getOriginCableOptions(){
            let originCablesArray = [];
            this.originCables.forEach(cable => {
                const fibers = [];
                cable.fibers.forEach(fiber =>{
                    const fiberFoundInOrigin = this.connections.find(item => item.origin.id === fiber.fb_id);
                    const fiberFoundInDestination = this.connections.find(item => item.destination.id === fiber.fb_id);
                    if(!fiberFoundInOrigin && !fiberFoundInDestination){
                        fibers.push({
                            id: fiber.fb_id,
                            label: `T${fiber.fb_nr_tube}/F${fiber.fb_nr_in_tube}`
                        });
                    }
                });
                if(fibers.length > 0){
                    originCablesArray.push({
                        id: cable.cb_id,
                        label: `CB:${cable.cb_label ? cable.cb_label : cable.cb_id}`,
                        children: [...fibers]
                    });
                };
            });
            let cablesList = {
                id: "cables",
                label: this.$i18n.tc("Cable", 2),
                children: [...originCablesArray]
            };
            return [cablesList];
        },
        getDestinationCableOptions(){
            let originCablesArray = [];
            this.destinationCables.forEach(cable => {
                const fibers = [];
                cable.fibers.forEach(fiber =>{
                    const fiberFoundInOrigin = this.connections.find(item => item.origin.id === fiber.fb_id);
                    const fiberFoundInDestination = this.connections.find(item => item.destination.id === fiber.fb_id);
                    if(!fiberFoundInOrigin && !fiberFoundInDestination){
                        fibers.push({
                            id: fiber.fb_id,
                            label: `T${fiber.fb_nr_tube}/F${fiber.fb_nr_in_tube}`
                        });
                    }
                });
                if(fibers.length > 0){
                    originCablesArray.push({
                        id: cable.cb_id,
                        label: `CB:${cable.cb_label ? cable.cb_label : cable.cb_id}`,
                        children: [...fibers]
                    });
                };
            });
            let cablesList = {
                id: "cable",
                label: this.$i18n.tc("Cable", 2),
                children: [...originCablesArray]
            };
            return [cablesList];
        },
        getOriginAndDestinationSplitterOptions(isInput, splitterSelectedHierarchy){
            const splitters = this.splitters.filter(item => item.sp_id !== this.selectedSplitter);
            const splittersArray = [];
            if(isInput){
                switch (splitterSelectedHierarchy) {
                    case 2:
                        //list splitter of level 1 connected to splitter
                        splitters.forEach(splitter => {
                            const ports = [];
                            const splitterHierarchy = this.getSplitterHierarchy(splitter.sp_id);
                            if(splitterHierarchy === 1 && this.splitterIsConnectedTo(true, splitter.sp_id)){
                                splitter.outPorts.forEach(port => {
                                    const isNotFree = this.portIsFree(port.pt_id);
                                    if(!isNotFree){
                                        ports.push({
                                            id: port.pt_id,
                                            label: `Output Port ${port.pt_nr_in_splitter}`
                                        });
                                    }
                                });
                            }
                            if(ports.length > 0){
                                splittersArray.push({
                                    id: splitter.sp_id,
                                    label: splitter.sp_label,
                                    children: [...ports]
                                })
                            }
                        });
                        break;
                    case 3:
                        //list splitter of level 2 connected to splitter
                        splitters.forEach(splitter => {
                            const ports = [];
                            const splitterHierarchy = this.getSplitterHierarchy(splitter.sp_id);
                            if(splitterHierarchy === 2 && this.splitterIsConnectedTo(true, splitter.sp_id)){
                                splitter.outPorts.forEach(port => {
                                    const isNotFree = this.portIsFree(port.pt_id);
                                    if(!isNotFree){
                                        ports.push({
                                            id: port.pt_id,
                                            label: `Output Port ${port.pt_nr_in_splitter}`
                                        });
                                    }
                                });
                            }
                            if(ports.length > 0){
                                splittersArray.push({
                                    id: splitter.sp_id,
                                    label: splitter.sp_label,
                                    children: [...ports]
                                })
                            }
                        });
                        break;
                    default:
                        break;
                }
            }else{
                switch (splitterSelectedHierarchy) {
                    case 0:
                        //dont have splitter connected
                        //list splitter with nivel 0 that are not connected to any fiber.
                        splitters.forEach(splitter => {
                            const ports = [];
                            const splitterHierarchy = this.getSplitterHierarchy(splitter.sp_id);
                            if(splitterHierarchy === 0 && !this.splitterHasInportsConnected(splitter.sp_id)){
                                splitter.inPorts.forEach(port => {
                                    const isNotFree = this.portIsFree(port.pt_id);
                                    if(!isNotFree){
                                        ports.push({
                                            id: port.pt_id,
                                            label: `Input Port ${port.pt_nr_in_splitter}`
                                        });
                                    }
                                });
                            }
                            if(ports.length > 0){
                                splittersArray.push({
                                    id: splitter.sp_id,
                                    label: splitter.sp_label,
                                    children: [...ports]
                                })
                            }
                        });
                        break;
                    case 1:
                        //first splitter of waterfall
                        //list splitter of nivel 2 of same waterfall
                        splitters.forEach(splitter => {
                            const splitterHierarchy = this.getSplitterHierarchy(splitter.sp_id);
                            const ports = [];
                            if(this.splitterIsConnectedTo(false, splitter.sp_id)){
                                splitter.inPorts.forEach(port => {
                                    const isNotFree = this.portIsFree(port.pt_id);
                                    if(!isNotFree){
                                        ports.push({
                                            id: port.pt_id,
                                            label: `Input Port ${port.pt_nr_in_splitter}`
                                        });
                                    }
                                });
                            }else if(splitterHierarchy === 0 && !this.splitterHasInportsConnected(splitter.sp_id)){
                                //list splitter of nivel 0 (don´t have any connection)
                                splitter.inPorts.forEach(port => {
                                    const isNotFree = this.portIsFree(port.pt_id);
                                    if(!isNotFree){
                                        ports.push({
                                            id: port.pt_id,
                                            label: `Input Port ${port.pt_nr_in_splitter}`
                                        });
                                    }
                                });
                            }else if(splitterHierarchy === 2){
                                //list splitter of nivel 0 (don´t have any connection)
                                splitter.inPorts.forEach(port => {
                                    const isNotFree = this.portIsFree(port.pt_id);
                                    if(!isNotFree){
                                        ports.push({
                                            id: port.pt_id,
                                            label: `Input Port ${port.pt_nr_in_splitter}`
                                        });
                                    }
                                });
                            }
                            if(ports.length > 0){
                                splittersArray.push({
                                    id: splitter.sp_id,
                                    label: splitter.sp_label,
                                    children: [...ports]
                                })
                            }
                        });
                        break;
                    case 2:
                        //second splitter of waterfall
                        //list splitter with nivel 0 that are not connected to any fiber.
                        //if it is connected to another splitter list splitter of nivel 3 of same waterfall
                        const hasOutportConnected = this.splitterHasOutPortConnected();
                        splitters.forEach(splitter => {
                            const ports = [];
                            const splitterHierarchy = this.getSplitterHierarchy(splitter.sp_id);
                            if(splitterHierarchy === 0 && !this.splitterHasInportsConnected(splitter.sp_id)){
                                splitter.inPorts.forEach(port => {
                                    const isNotFree = this.portIsFree(port.pt_id);
                                    if(!isNotFree){
                                        ports.push({
                                            id: port.pt_id,
                                            label: `Input Port ${port.pt_nr_in_splitter}`
                                        });
                                    }
                                });
                            }else if(splitterHierarchy === 3 && this.splitterIsConnectedTo(false, splitter.sp_id)){
                                splitter.inPorts.forEach(port => {
                                    const isNotFree = this.portIsFree(port.pt_id);
                                    if(!isNotFree){
                                        ports.push({
                                            id: port.pt_id,
                                            label: `Input Port ${port.pt_nr_in_splitter}`
                                        });
                                    }
                                });
                            }else if(splitterHierarchy === 3){
                                //list splitter of nivel 0 (don´t have any connection)
                                splitter.inPorts.forEach(port => {
                                    const isNotFree = this.portIsFree(port.pt_id);
                                    if(!isNotFree){
                                        ports.push({
                                            id: port.pt_id,
                                            label: `Input Port ${port.pt_nr_in_splitter}`
                                        });
                                    }
                                });
                            }
                            if(ports.length > 0){
                                splittersArray.push({
                                    id: splitter.sp_id,
                                    label: splitter.sp_label,
                                    children: [...ports]
                                })
                            }
                        })
                        break;
                    default:
                        break;
                }
            }
            let splittersList = {
                id: "splitters",
                label: this.$i18n.tc("Splitters", 2),
                children: [...splittersArray]
            };
            return [splittersList];
        },
        splitterHasOutPortConnected(){
            let isConnected = false;
            const splitter = this.splitters.find(item => item.sp_id === this.selectedSplitter);
            splitter.outPorts.forEach(port => {
                if(port.connectedPort){
                    isConnected = true;
                    return false;
                }
            })
            return isConnected;
        },
        splitterIsConnectedTo(isInput, id){
            let connectionExists;
            if(isInput){
                connectionExists = this.connections.filter(item => {
                    return ((item.destination.parent.id === this.selectedSplitter) && (item.origin.parent.id === id))
                });
            }else{
                connectionExists = this.connections.filter(item => {
                    return ((item.origin.parent.id === this.selectedSplitter) && (item.destination.parent.id === id))
                });
            }
            return (connectionExists.length > 0);
        },
        splitterHasInportsConnected(spId){
            let isConnected = false;
            this.splitterPortsCache[spId].inputs.forEach(port => {
                const foundInDestination = this.connections.find(item => item.destination.id === port.pt_id);
                if(!foundInDestination){
                    const foundInOrigin = this.connections.find(item => item.origin.id === port.pt_id);
                    if(foundInOrigin){
                        isConnected = true;
                        return false;
                    }
                }else{
                    isConnected = true;
                    return false
                }
            });
            return isConnected;
        },
        getOriginAndDestinationCableOptions(){
            const originCablesArray = this.getOriginCableOptions();
            let destinationCablesArray = []; 
            this.destinationCables.forEach(cable => {
                const fibers = [];
                cable.fibers.forEach(fiber =>{
                    const fiberFoundInDestination = this.connections.find(item => item.destination.id === fiber.fb_id);
                    const fiberFoundInOrigin = this.connections.find(item => item.origin.id === fiber.fb_id);
                    if(!fiberFoundInDestination && !fiberFoundInOrigin){
                        fibers.push({
                            id: fiber.fb_id,
                            label: `T${fiber.fb_nr_tube}/F${fiber.fb_nr_in_tube}`
                        });
                    }
                });
                if(fibers.length > 0){
                    destinationCablesArray.push({
                        id: cable.cb_id,
                        label: `CB:${cable.cb_label ? cable.cb_label : cable.cb_id}`,
                        children: [...fibers]
                    });
                };
            });
            let cablesList = {
                id: "cables",
                label: this.$i18n.tc("Cable", 2),
                children: [...originCablesArray[0].children, ...destinationCablesArray]
            };
            return [cablesList];
        },
        setPortOrSplitterId(){
            if(Array.isArray(this.selectedConnectionPoint)){
                this.selectedFiberOrPort = this.selectedConnectionPoint[0].fb_id;
            }else{
                this.selectedSplitter = this.selectedConnectionPoint.origin.connectionPoints[0].pt_splitter_id;
                this.isSplitterDisabled = true;
            }
        },
        getfiberOrPortObject(){
            let isFound = false;
            let isOrigin = false;
            let fiberOrPort;
            //search in origin fibers
            this.originCables.forEach(cable =>{
                const fiberOrPortFound = cable.fibers.find(fiber => fiber.fb_id === this.selectedFiberOrPort);
                if(fiberOrPortFound){
                    fiberOrPort = {...fiberOrPortFound}
                    fiberOrPort.type = "fiber";
                    isFound = true;
                    isOrigin = true;
                }
            });
            //search in destination fibers
            if(!isFound){
                this.destinationCables.forEach(cable =>{
                    const fiberOrPortFound = cable.fibers.find(fiber => fiber.fb_id === this.selectedFiberOrPort);
                    if(fiberOrPortFound){
                        fiberOrPort = {...fiberOrPortFound}
                        fiberOrPort.type = "fiber";
                        isFound = true;
                    }
                });
            }
            //search in splitters
            if(!isFound){
                this.splitters.forEach(splitter => {
                    const inputPort = splitter.inPorts.find(item => item.pt_id === this.selectedFiberOrPort);
                    if(inputPort){
                        fiberOrPort = {...inputPort}
                        fiberOrPort.type = "port";
                    }else{
                        const outputPort = splitter.outPorts.find(item => item.pt_id === this.selectedFiberOrPort);
                        if(outputPort){
                            fiberOrPort = {...outputPort}
                            fiberOrPort.type = "port";
                        }
                    }

                })
            }
            return {isOrigin, obj: fiberOrPort};
        },
        getSplitterHierarchy(splitterID){
            const splitters = [];
            this.getSpilttersConnected(splitterID, splitters);
            //delete duplicates from array
            const jsonObject = splitters.map(JSON.stringify);
            const uniqueSet = new Set(jsonObject);
            const uniqueArray = Array.from(uniqueSet).map(JSON.parse);
            return (uniqueArray.length);
        },
        getSpilttersConnected(spId, spArray){
            //check if splitter was already added
            let hasOutportConnected = false;
            let hasInportConnected = false;
            const findSplitter = spArray.find(item => item.sp_id === spId);
            if(!!findSplitter || !(!!spId)){
                return;
            }
            const splitter = this.splitters.find(splitter => splitter.sp_id === spId);
            let nextSpId;
            splitter.inPorts.forEach(port => {
                if(!!port.connectedPort){
                    hasOutportConnected = true;
                    const checkSplitterExists = spArray.find(item => item.sp_id === port.connectedPort.pt_splitter_id);
                    if(!(!!checkSplitterExists)){
                        nextSpId = port.connectedPort.pt_splitter_id;
                        spArray.push({
                            sp_id: splitter.sp_id,
                        });
                    }
                }
            });
            if(!hasOutportConnected){
                splitter.outPorts.forEach(port => {
                    if(!!port.connectedPort){
                        hasInportConnected = true;
                    }
                });
                if(hasInportConnected){
                    spArray.push({
                        sp_id: splitter.sp_id,
                    });
                }
            }
            this.getSpilttersConnected(nextSpId, spArray);
        },
    }
  }
  </script>
  
<style>
.connection-splicing-title-container{
    margin: 0px 15px;
}
.connection-splicing-form-container{
    height: 50px;
    gap: 20px;
    margin: 20px 15px;
}
.connection-splicing-form-item{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
}
.connection-splicing-button{
    background-color: #4fa2b7 !important;
    color: white !important;
    text-transform: none;
}
.connection-splicing-button-active{
    background-color: rgba(79,162, 183, 0.4) !important;
    color: #4fa2b7 !important;
    text-transform: none;
    border: 1px solid #4fa2b7;
}
.connection-splicing-input{
    height: 32px;
    width: 100%;
    border: 1px solid lightgray;
    border-radius: 10px;
    padding-left: 10px;
    font-style: italic;
}
.vue-treeselect__control{
    border-radius: 10px !important;
}
input::-webkit-input-placeholder{
    color:black;
}
.connection-splicing-input:-moz-placeholder {
    color:black;
}
.connection-splicing-form-item .vue-treeselect .vue-treeselect__menu-container{
    font-size: 12px !important;
}
.connection-splicing-form-item .vue-treeselect .vue-treeselect__menu-container .vue-treeselect__menu{
    max-height: 105px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/CreateConnectionForm.vue